// extracted by mini-css-extract-plugin
export default {"imgContain":"PA","content":"QA","titleAndImage":"RA","title":"SA","text":"TA","rhodeTitle":"UA","shortHR":"VA","modal_root":"WA","x_mark":"XA","flavorStickModal":"YA","greenBox":"ZA"};
    if(module.hot) {
      // 1713996747403
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  